var escape = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img[data-v-d87f26e4]{margin-left:30px;height:612px;width:404px;background:url(" + escape(require("../assets/img/theme-set.jpg")) + ") no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d87f26e4","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./src/docs/theme.md
// module id = GxgP
// module chunks = 0